import { Button, ClickAwayListener, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, MenuItem, Radio, RadioGroup, Select } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { MutableRefObject, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { matDropDownStyle } from "../../assets/style/material/matSyles";
import { inputValidation } from "../../helpers/commonHelpers";
import { useGeneralPairing } from "../../providers/GeneralPairing";
import { usePairingPackage } from "../../providers/PairingPackage";

import "./AddFavorites.scss";

export default function AddFavorites({ search, pairingId, toggleDisplay = f => f }) {
    const { t } = useTranslation();
    const noCategory = t('pairingPackage.noCategories');
    const dropDownClasses = matDropDownStyle();
    const generalPairingContext = useGeneralPairing();
    const pairingPackageContext = usePairingPackage();
    const [categoryType, setCategoryType] = useState(generalPairingContext.list.length ? 'select' : 'new');
    const [selectedCategory, setSelectedCategory] = useState(generalPairingContext.list.length ? generalPairingContext.list[0].name : '');
    const [error, setError] = useState(false);
    const [errorMax, setErrorMax] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const newCategoryTextFieldRef = useRef() as MutableRefObject<HTMLInputElement>;
    
    const handleChange = (event) => {
      setCategoryType(event.target.value);
      if(event.target.value === 'select') {
        newCategoryTextFieldRef.current.value = '';
        setNewCategoryName('');
        setError(false);
        // setErrorMax(false);
      }
    };

    const handleCatChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    const addToCategory = async () => {
        if (error) {
            return;
        }
        if ((categoryType === 'new') && !newCategoryName) {
            setError(true); setErrorMax(false);
            return;
        }
        categoryType === 'select' ?
            await generalPairingContext.addToCategory(search, selectedCategory, pairingId) :
            await generalPairingContext.addToCategory(search, newCategoryName, pairingId);
        toggleDisplay(null);
        pairingPackageContext.getPairingPackageData(search);
    }

    const handleValidation = (e) => {
        if (!inputValidation(e.target.value.trim())) {
            setError(true);
            setErrorMax(false);
        }else if (e.target.value.length >= e.target.maxLength) {
            setErrorMax(true);
            setError(false);
        }else {
            setError(false);
            setErrorMax(false);
            setNewCategoryName(e.target.value.trim());
        }
    }

    const selectClass = `${dropDownClasses.select} ${dropDownClasses.selectForFavourites}`;

    return (
        <ClickAwayListener onClickAway={toggleDisplay} mouseEvent='onMouseUp'>
            <div className='add-favorites-container'>
                <div className='add-favorites-modal'>
                    <Grid className="title" container item justifyContent='space-between'>
                        <Grid item>
                            <div className='modal-title'>{t('pairingPackage.addPairing')}</div>
                        </Grid>
                        <Grid item>
                            <CloseIcon className='icon-close-modal' onClick={toggleDisplay} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className='edit-columns-list'>
                                <FormGroup>
                                    <RadioGroup
                                        aria-label="categoryType"
                                        name="controlled-radio-buttons-group"
                                        value={categoryType}
                                        onChange={handleChange}
                                    >
                                        <FormControlLabel className="existing-category-input"
                                            value="select"
                                            control={<Radio />}
                                            disabled={!(generalPairingContext.list.length)}
                                            label={
                                                <FormControl>
                                                    <div className="existing-category">
                                                        <div className="category-label">{t('pairingPackage.existingCategory')}</div>
                                                        <Select                                                        
                                                            className={selectClass}
                                                            labelId="demo-simple-select-label"
                                                            value={generalPairingContext.list.length ? selectedCategory : noCategory}
                                                            label={"CategoryName"}
                                                            disabled={categoryType === 'new'}
                                                            onChange={handleCatChange}
                                                            disableUnderline                                                     
                                                        >
                                                            {generalPairingContext.list.length ?
                                                                generalPairingContext.list.map(category => <MenuItem value={category.name}>{category.name}</MenuItem>) :
                                                                <MenuItem value={noCategory}>{noCategory}</MenuItem>
                                                            }
                                                        </Select>
                                                    </div>
                                                </FormControl>
                                            }
                                        />
                                        <FormControlLabel className="new-category-input"
                                            value="new"
                                            control={<Radio />}
                                            label={
                                                <div className="new-category">
                                                    <div className="category-label">{t('pairingPackage.newCategory')}</div>
                                                    <input type="text" ref={newCategoryTextFieldRef} className= {error || errorMax ? 'input-textfield text-error' : 'input-textfield'} placeholder={t('pairingPackage.newCategoryPlaceHolder')} disabled={categoryType === 'select'} onKeyUp={(e) => handleValidation(e)} minLength = {0} maxLength = {31}/>
                                                    <FormHelperText className="category-name-error">
                                                        {error && <><i className='icon-circle-flight' /><span>{t('pairingPackage.invalidName')}</span></>}
                                                        {errorMax && <><i className='icon-circle-flight' /><span>{t('editTableColumns.preset-max-error')}</span></>}                         
                                                    </FormHelperText>
                                                </div>
                                            }
                                        />
                                    </RadioGroup>
                                </FormGroup>
                            </div>
                        </Grid>
                    </Grid>
                    {/* <hr className='MuiDivider-root'></hr> */}
                    <Grid container direction='column' spacing={2} className={error || errorMax ? 'btn-spacing-top-error' : 'btn-spacing-top'}>
                        <Grid container item xs={12}>
                            <Button className='btn-modal-black' disabled={error || errorMax } onClick={addToCategory}>{t('pairingPackage.addToMyPairing')}</Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </ClickAwayListener>
    );
}